document.addEventListener('DOMContentLoaded', () => {
  const searchFilter = new SearchFilter()
  searchFilter.init()
})

class SearchFilter {
  constructor () {
    this.SEARCH_SECTIONS = document.querySelectorAll('.mt-search-page')
    this.SEARCH_SECTION = ''
    this.POST_TYPE = 'any'
    this.SEARCH = ''
    this.PAGE = 1
  }

  init () {
    if (this.SEARCH_SECTIONS.length > 0) {
      this.SEARCH_SECTIONS.forEach(SEARCH_SECTION => {
        this.SEARCH_SECTION = SEARCH_SECTION
        this.addEventListeners()
      })
    }
  }

  addEventListeners() {
    this.FILTER_BUTTONS = this.SEARCH_SECTION.querySelectorAll('.mt-search-page__filters button')
    this.FILTER_FORM = this.SEARCH_SECTION.querySelector('.mt-search-page__search-box')
    this.FILTER_SEARCH = this.SEARCH_SECTION.querySelector('.mt-search-page__input')
    this.SEARCH_GRID = this.SEARCH_SECTION.querySelector('.mt-search-page__results')

    let searchTimer = null;

    if (this.FILTER_BUTTONS.length > 0) {
      for (let index = 0; index < this.FILTER_BUTTONS.length; index++) {
        const button = this.FILTER_BUTTONS[index]

        button.addEventListener('click', () => {
          this.POST_TYPE = button.getAttribute('data-post-type')

          this.changeActivePostType()
          this.getSearchResults()
        })
      }
    }
    if(this.FILTER_FORM) {
      this.FILTER_FORM.addEventListener('submit', event => {
        event.preventDefault();
      });
    }
    if(this.FILTER_SEARCH){
      this.FILTER_SEARCH.addEventListener('input', (e) => {
        e.preventDefault();

        if(searchTimer == null){
          searchTimer = setTimeout(() => {
            this.getSearchResults();
          }, 500);
        }
        else{
          clearTimeout(searchTimer);
          searchTimer = setTimeout(() => {
            this.getSearchResults();
          }, 500);
        }
      })
    }
    document.addEventListener('click', (e) => {
      if (e.target?.classList.contains('page-numbers')) {
        e.preventDefault()
        const value = +e.target?.innerHTML
        if(typeof value === 'number'  && !Number.isNaN(value)){
          this.PAGE = value
        }else {
          if(e.target?.classList.contains('prev')){
            this.PAGE = this.PAGE - 1
          }else {
            this.PAGE = this.PAGE + 1
          }
        }
        this.getSearchResults();
      }
    })
  }

  getSearchString() {
    const SEARCH_INPUT = this.SEARCH_SECTION.querySelector('.mt-search-page__input')
    this.SEARCH = SEARCH_INPUT.value
  }

  changeActivePostType(){
    this.SEARCH_SECTION.querySelector('.mt-search-page__filters button.active').classList.remove('active')
    this.SEARCH_SECTION.querySelector('.mt-search-page__filters button[data-post-type="'+this.POST_TYPE+'"]').classList.add('active')
  }

  getSearchResults(){
    this.getSearchString()
    this.SEARCH_SECTION.querySelector('.mt-loader').classList.add('show')
    const SEARCH_STRING = this.SEARCH_SECTION.querySelector('.search-string')
    const SEARCH_POSTS_COUNT = this.SEARCH_SECTION.querySelector('.search-posts-count')
    const REST_URL = this.SEARCH_SECTION.getAttribute('data-rest-url')
    const data = {
      post_type: this.POST_TYPE,
      s: this.SEARCH,
      page: this.PAGE
    }

    jQuery.get(REST_URL, data, (response) => {
      if (response !== 0) {
        this.SEARCH_GRID.innerHTML = response.posts
        this.SEARCH_SECTION.querySelector('.mt-loader').classList.remove('show')
        SEARCH_STRING.innerHTML = this.SEARCH
        SEARCH_POSTS_COUNT.innerHTML = response.total_posts
        this.SEARCH_SECTION.querySelector('.mt-search-page__pagination').innerHTML = response.pagination
      }
    })
  }
}
